import { generateUrl } from "@services/generateUrl/generateUrl"
import { onRequestSuccess, onResponseRejected } from "@services/interceptors"
import axios from "axios"

const FINANCIAL_URL = generateUrl()

const fcFinancialServiceApiInstance = axios.create({
    baseURL: `${FINANCIAL_URL}/fcfinancial/api/v1`
})

fcFinancialServiceApiInstance.interceptors.request.use(onRequestSuccess, undefined)
fcFinancialServiceApiInstance.interceptors.response.use(undefined, onResponseRejected)

export default fcFinancialServiceApiInstance
